import React, { useState } from "react";

import { Button, Col, Form, Modal, Row } from "react-bootstrap";

import { ReactSVG } from "react-svg";

import { VectorIcon } from "@assets/icons";

import styles from "./DateRangePickerModal.module.scss";

interface DateRangePickerModalProps {
  show: boolean;
  onHide: () => void;
  onApply: (startDate: string, endDate: string) => void;
}

const DateRangePickerModal: React.FC<DateRangePickerModalProps> = ({ show, onHide, onApply }) => {
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const handleApply = () => {
    if (startDate && endDate) {
      onApply(startDate, endDate);
      onHide();
    }
  };

  const handleDateChange = (
    setter: React.Dispatch<React.SetStateAction<string | null>>,
    value: string,
    isStart: boolean,
  ) => {
    const time = isStart ? "00:00:00" : "23:59:59";
    const date = value ? new Date(`${value}T${time}`).toISOString() : null;
    setter(date);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton />
      <Modal.Body>
        <Row className="mb-4">
          <Col xs={12} className="text-center">
            <h4>Reported date range</h4>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center align-items-center">
          <Col xs={5}>
            <Form.Group controlId="formStartDate">
              <Form.Label>From</Form.Label>
              <Form.Control
                type="date"
                onChange={(e) => handleDateChange(setStartDate, e.target.value, true)}
                placeholder="Start date"
              />
            </Form.Group>
          </Col>
          <Col xs="auto" className="d-flex justify-content-center align-items-center">
            <ReactSVG src={VectorIcon} className={styles.vectorIcon} />
          </Col>
          <Col xs={5}>
            <Form.Group controlId="formEndDate">
              <Form.Label>To</Form.Label>
              <Form.Control
                type="date"
                onChange={(e) => handleDateChange(setEndDate, e.target.value, false)}
                placeholder="End date"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mt-4 mb-4 text-center">
          <Col>
            <Button variant="primary" onClick={handleApply} disabled={!startDate || !endDate}>
              Next
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default DateRangePickerModal;
